import { cn } from "@/components/ui/cn";

/**
 * Shared chrome for the cards that sit beside the OTT player: a series' episode
 * list and a single video's chapter list. They fill the same rail slot (never
 * both at once), so they must read as one family — same radius, same bordered
 * header, same title/meta scale. Before this wrapper the two had drifted (a
 * bold 14px header vs an uppercase eyebrow) in the very slot that swaps them.
 */
export function OttRailCard({
  title,
  meta,
  className,
  children,
}: {
  title: string;
  /** Right-aligned header meta — a count, a runtime. */
  meta?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <section
      className={cn("overflow-hidden rounded-card border border-border/60 bg-card", className)}
    >
      <header className="flex items-baseline justify-between gap-3 border-b border-border/60 px-5 py-3.5">
        <h2 className="!m-0 font-display !text-[14px] !font-bold !leading-5 !text-foreground">
          {title}
        </h2>
        {meta ? (
          <p className="shrink-0 text-[12px] font-medium tabular-nums text-muted-foreground">
            {meta}
          </p>
        ) : null}
      </header>
      {children}
    </section>
  );
}
